import { render, staticRenderFns } from "./petrenger.vue?vue&type=template&id=96d19fe6"
import script from "./petrenger.vue?vue&type=script&lang=js"
export * from "./petrenger.vue?vue&type=script&lang=js"
import style0 from "./petrenger.vue?vue&type=style&index=0&id=96d19fe6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports